import { Outlet, Link, useNavigate } from "react-router-dom";
import "./Home.css";
import { useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useCartContext } from "../../hooks";
import { AiOutlineHome } from "react-icons/ai";
import { LuShoppingBasket } from "react-icons/lu";
import { CgProfile } from "react-icons/cg";
import { MdOutlineShoppingCart } from "react-icons/md";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { IoMdArrowRoundBack } from "react-icons/io";
import { Badge } from "@chakra-ui/react";
import { themeColours } from "../../resources";

export function Home() {
  const location = useLocation();
  const currentPath = location.pathname;
  const navigate = useNavigate();
  const [showNav, setShowNav] = useState(false);
  const { cartState } = useCartContext();
  const itemsInCart = Object.keys(cartState).length;
  const isShop = localStorage.getItem("isShop") === "T";
  const navBarRef = useRef<HTMLDivElement>(null);

  function handleOutsideClick(event: MouseEvent) {
    if (navBarRef.current && !navBarRef.current.contains(event.target as Node)) {
      setShowNav(false);
    }
  }

  function handleEndGuide() {
    [
      "isGuide",
      "shopCheck",
      "feedbackCheck",
      "priceCheck",
      "recentsCheck",
      "templateCheck",
      "storeCheck",
      "titleCheck",
      "catCheck",
      "brandCheck",
      "volumeCheck",
      "searchCheck",
      "cartCheck",
    ].map((key) => localStorage.removeItem(key));
    return navigate("/guide");
  }

  function handleBackGuide() {
    switch (currentPath) {
      case "/guide/shop":
        return navigate("/guide/home");
      case "/guide/template":
        return navigate("/guide/home");
      case "/guide/results":
        return navigate("/guide/shop");
      case "/guide/cart":
        return navigate("/guide/results");
    }
  }

  function handleBackArrow() {
    return navigate("/");
  }

  useEffect(() => {
    if (showNav) document.addEventListener("mousedown", handleOutsideClick);
    else document.removeEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [showNav]);

  const isGuide = localStorage.getItem("isGuide") === "T";
  const showBackArrow = ["/guide", "/templates", "/feedback"].includes(currentPath);
  let directory = "";
  switch (currentPath) {
    case "/guide":
      directory = "Guide";
      break;
    case "/shop":
      directory = "";
      break;
    case "/templates":
      directory = "Templates";
      break;
    case "/feedback":
      directory = "Feedback";
      break;
    case "/basket":
      directory = "";
      break;
    case "/profile":
      directory = "";
  }

  return (
    <div className="appContainer">
      {isGuide ? (
        <div className="topGuideContainer">
          <IoMdArrowRoundBack
            size={30}
            color={currentPath === "/guide/home" ? "transparent" : themeColours.primary}
            onClick={handleBackGuide}
          />
          <IoIosCloseCircleOutline size={30} color={themeColours.red} onClick={handleEndGuide} />
        </div>
      ) : (
        <div className="topNavContainer">
          {showBackArrow && (
            <IoMdArrowRoundBack size={25} color={"#FFFFFF"} onClick={handleBackArrow} className="backArrowIcon" />
          )}
          <text>{directory}</text>
        </div>
      )}
      {!isGuide && (
        <div className="navContainer" ref={navBarRef}>
          <Link to="" className={`navLink ${currentPath === "/" ? "selected" : ""}`}>
            <AiOutlineHome className="navLinkIcon" size={20} color={"#FFFFFF"} />
            Home
          </Link>
          <Link to="shop" className={`navLink ${currentPath === "/shop" ? "selected" : ""}`}>
            <MdOutlineShoppingCart className="navLinkIcon" size={20} color={"#FFFFFF"} />
            Shop
          </Link>
          <span className={`navLink ${currentPath === "/basket" ? "selected" : ""}`}>
            <span className="cartSpan">
              <LuShoppingBasket
                className="topNavContainerCart"
                size={20}
                color={"#FFFFFF"}
                onClick={() => {
                  return navigate("/basket");
                }}
              />
              {isShop && (
                <Badge colorScheme="green" borderRadius={"16px"} fontSize={8} height={3} className="cartNumBadge">
                  <text>{itemsInCart}</text>
                </Badge>
              )}
            </span>
            Cart
          </span>
          <Link to="profile" className={`navLink ${currentPath === "/profile" ? "selected" : ""}`}>
            <CgProfile className="navLinkIcon" size={20} color={"#FFFFFF"} />
            Profile
          </Link>
        </div>
      )}
      <Outlet />
    </div>
  );
}
